import style from '../../index.css'
import bgStyle from '../../stylesheets/background.css'

let fgEls = []
let bgEls = []

export const setActiveElementClass = {
  onCurrentChanged(currentSection, dispatch) {
    const { foregroundElement, backgroundElement } = currentSection

    if (!fgEls || !fgEls.length) {
      fgEls = [...document.querySelectorAll(`.${style.section}`)]
      bgEls = [...document.querySelectorAll(`.${bgStyle.background}`)]
    }

    const index = fgEls.indexOf(foregroundElement)
    const activeEls = shouldBeActive(index, fgEls, bgEls)

    fgEls.forEach(fgEl => {
      if (fgEl === foregroundElement) {
        addOrRemoveClass(fgEl, style['section--ready'], 'remove')
        addOrRemoveClass(fgEl, style['section--active'], 'add')
      } else if (activeEls.fgEls.indexOf(fgEl) >= 0) {
        addOrRemoveClass(fgEl, style['section--active'], 'remove')
        addOrRemoveClass(fgEl, style['section--ready'], 'add')
      } else {
        addOrRemoveClass(fgEl, style['section--ready'], 'remove')
        addOrRemoveClass(fgEl, style['section--active'], 'remove')
      }
    })

    bgEls.forEach(bgEl => {
      if (bgEl === backgroundElement) {
        addOrRemoveClass(bgEl, bgStyle['background--ready'], 'remove')
        addOrRemoveClass(bgEl, bgStyle['background--active'], 'add')
      } else if (activeEls.bgEls.indexOf(bgEl) >= 0) {
        addOrRemoveClass(bgEl, bgStyle['background--active'], 'remove')
        addOrRemoveClass(bgEl, bgStyle['background--ready'], 'add')
      } else {
        addOrRemoveClass(bgEl, bgStyle['background--active'], 'remove')
        addOrRemoveClass(bgEl, bgStyle['background--ready'], 'remove')
      }
    })
  }
}

function addOrRemoveClass(el, className, action = 'add') {
  if (!el || !el.classList || !className) return
  if (action === 'remove') {
    return el.classList.contains(className) && el.classList.remove(className)
  }
  if (!el.classList.contains(className)) return el.classList.add(className)
}

function shouldBeActive(index, fgEls, bgEls, buffer = 3) {
  if (index < 0) return { fg: [], bg: [] }
  if (index === 0 && fgEls.length > buffer) {
    return {
      fgEls: fgEls.slice(0, buffer + 1),
      bgEls: bgEls.slice(0, buffer + 1)
    }
  } else if (index > 0) {
    if (fgEls.length > index + buffer) {
      const root = index - buffer
      return {
        fgEls: fgEls.slice(root > 0 ? root : 0, index + buffer + 1),
        bgEls: bgEls.slice(root > 0 ? root : 0, index + buffer + 1)
      }
    }
    return {
      fgEls: fgEls.slice(index - buffer, fgEls.length),
      bgEls: bgEls.slice(index - buffer, fgEls.length)
    }
  }
  return { fgEls: [], bgEls: [] }
}



// WEBPACK FOOTER //
// ./src/shared/components/renderless/activeClass.js